<template>
  <div
    class="home-container"
    :class="{ dark }"
  >
    <TemperatureGauge v-if="dark" />
    <div
      class="home-box"
      :class="{ dark }"
    >
      <div
        class="home-box__title"
        :class="{ dark }"
      >
        WELCOME USER
      </div>
      <div :class="{ 'home-box__user-dark': dark, 'home-box__user': !dark }">
        <span
          v-if="dark"
          class="text-teal-dark"
        >[</span>
        <span>{{ username }}</span>
        <span
          v-if="dark"
          class="text-teal-dark"
        >]</span>
      </div>
    </div>
    <TemperatureAnimations v-if="dark" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TemperatureGauge from '@/components/Layout/TemperatureGauge'
import TemperatureAnimations from '@/components/Layout/TemperatureAnimations'

export default {
  name: 'Home',

  components: {
    TemperatureAnimations,
    TemperatureGauge,
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),

    ...mapGetters({
      username: 'auth/username',
    }),
  },
}
</script>
<style lang="postcss" scoped>
.home {
  &-container {
    background-image: url('../../assets/asset-1-eb-web-bg-1.png');
    @apply h-full w-full flex justify-center items-center;

    &.dark {
      background-image: url('../../assets/dark/eb-website-dark-bg.png');
    }
  }

  &-box {
    min-height: 200px;
    background-color: rgba(5, 26, 57, 0.87);
    font-family: 'univia-pro';
    @apply flex flex-col justify-center items-center text-teal-dark p-4 m-4;

    &.dark {
      @apply border border-blue;
      font-family: 'input-mono';
      color: rgba(37, 109, 147, 0.4);
      @apply flex-row bg-almost-black;
    }

    &__title {
      font-size: 24px;
      @apply mb-8;

      &.dark {
        font-family: 'input-mono';
        color: rgba(37, 109, 147, 0.4);
        @apply mb-0 mr-8;
      }
    }

    &__user {
      font-size: 95px;
      @apply py-4 px-8 relative;

      &-dark {
        color: rgba(216, 216, 216, 0.4);
      }
      &:before,
      &:after,
      & > :first-child:before,
      & > :first-child:after {
        position: absolute;
        width: 30px;
        height: 30px;
        border-color: rgba(37, 109, 146, 0.7);
        border-style: solid;
        content: ' ';
      }
      &:before {
        top: 0;
        left: 0;
        border-width: 2px 0 0 2px;
      }
      &:after {
        top: 0;
        right: 0;
        border-width: 2px 2px 0 0;
      }
      & > :first-child:before {
        bottom: 0;
        right: 0;
        border-width: 0 2px 2px 0;
      }
      & > :first-child:after {
        bottom: 0;
        left: 0;
        border-width: 0 0 2px 2px;
      }
    }
  }
}

@screen sm {
  .home {
    &-box {
      width: 675px;
      height: 336px;
    }

    &__title {
      font-size: 50px;

      &.dark {
        font-size: 43px;
      }
    }

    &__user {
      &-dark {
        font-size: 43px;
      }
    }
  }
}
</style>
